export default __webpack_public_path__ + "static/remeltedwax-31d300e00dcf85cb69c3c50a7ba8b4b3.png";